import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses';
import { t } from '../../../common/i18n';
import { WorkingHours } from '../../PbxAccordionContent/WorkingHours';
import type { ReachabilityWithMobileFormValues } from '../../PbxAccordionContent/PbxAccordionUtils';

interface MobileWorkingHoursProps {
  addonAttributes: ReachabilityWithMobileFormValues;
  edit: boolean;
}

export const MobileWorkingHours = ({ addonAttributes, edit }: MobileWorkingHoursProps) => (
  <CL.Grid className={dsClass.PADDING_TOP_6}>
    <CL.GridRow>
      <CL.GridCol colsXS={4} colsS={6} colsM={6} colsL={12} colsXL={12}>
        <div className={`${dsClass.PADDING_BOTTOM_4} ${dsClass.DISPLAY_FLEX} ${dsClass.ALIGN_ITEMS_CENTER}`}>
          <h4 className={`${dsClass.MARGIN_TOP_0} ${dsClass.MARGIN_BOTTOM_0} ${dsClass.PADDING_RIGHT_2}`}>
            {t.LC1S('Scheduled office hours for mobile number')}
          </h4>
          <CL.Tooltip
            triggerElement={<CL.Icon className="custom-icon" color="secondary-blue-600" icon="information" size="s" />}
            placement="top"
            i18n_tooltip_contentText={t.HGNO(
              'Select if the active state for the mobile number should be during office hours, outside of office hours, or according to scheduled office hours. ' +
                'If you select the last option, you can set the time range when office-hour respondents are used. Outside of these hours, out-of-office respondents are used. ' +
                'If you want to use the out-of-office respondents for the entire weekend, set the time to 00.00 - 00.00.'
            )}
          />
        </div>
      </CL.GridCol>
    </CL.GridRow>
    <CL.GridRow
      className={
        edit
          ? `${dsClass.PADDING_TOP_4} ${dsClass.PADDING_LEFT_4}  ${dsClass.PADDING_RIGHT_2} of-pbx-accordion-content__working-hours`
          : undefined
      }
    >
      <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
        <WorkingHours
          title={t.EBAT('On weekdays')}
          namePrefix="workingHoursWeekday"
          start={addonAttributes?.workingHoursWeekdayStart}
          end={addonAttributes?.workingHoursWeekdayEnd}
          edit={edit}
        />
      </CL.GridCol>

      <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
        <WorkingHours
          title={t.ZZK7('On weekends')}
          namePrefix="workingHoursWeekend"
          start={addonAttributes?.workingHoursWeekendStart}
          end={addonAttributes?.workingHoursWeekendEnd}
          edit={edit}
        />
      </CL.GridCol>
    </CL.GridRow>
  </CL.Grid>
);
